import { memo, useMemo } from 'react';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { PermissionsContext } from '../contexts/PermissionsContext';
import { ProductActionsProvider } from '../providers/ProductActionsProvider';
import { ProductDependenciesProvider } from '../providers/ProductDependenciesProvider';
import { ProductHighlightModalsProvider } from '../providers/ProductHighlightModalsProvider';
import { ErrorBoundary } from 'commerce-products-lib/errors/ErrorBoundary';
import { ProductHighlightError } from './errors/ProductHighlightError';
import { ProductHighlightContent } from './ProductHighlightContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductHighlight = ({
  objectId,
  onObjectCreate,
  onObjectUpdate,
  onObjectDelete,
  updatePreview,
  closeSidebar,
  hasScope,
  hasGate
}) => {
  const permissionsContextValue = useMemo(() => {
    return {
      hasScope,
      hasGate
    };
  }, [hasScope, hasGate]);
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    boundaryName: "product-highlight-card-error-boundary",
    ErrorComponent: /*#__PURE__*/_jsx(ProductHighlightError, {}),
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(ProductHighlightModalsProvider, {
      children: /*#__PURE__*/_jsx(ProductDependenciesProvider, {
        objectId: objectId,
        children: /*#__PURE__*/_jsx(ProductActionsProvider, {
          onObjectCreate: onObjectCreate,
          onObjectUpdate: onObjectUpdate,
          updatePreview: updatePreview,
          onObjectDelete: onObjectDelete,
          closeSidebar: closeSidebar,
          children: /*#__PURE__*/_jsx(PermissionsContext.Provider, {
            value: permissionsContextValue,
            children: /*#__PURE__*/_jsx(ProductHighlightContent, {})
          })
        })
      })
    })]
  });
};
export default /*#__PURE__*/memo(ProductHighlight);